// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import constants from "@store/constants";

import * as React from "react";
import { FC } from "react";

const enum fields {
    author = "author",
    publishDate = "publishDate",
    tileImage = "tileImage",
}

interface BlogArticlePageProps extends PageProps {
    fields: {
        [fields.author]: string;
        [fields.publishDate]: string;
        [fields.tileImage]: string;
    };
}

const BlogArticlePage: FC<BlogArticlePageProps> = ({ id }) => (
    <MobiusPage>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const settingsTab = {
    displayName: "Settings",
    sortOrder: 2,
};

const pageModule: PageModule = {
    component: BlogArticlePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedParents: [constants.pageType.blogCategoryPage],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                ...HorizontalRule,
            },
            {
                name: fields.tileImage,
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                fieldType: "Contextual",
                isRequired: true,
                tooltip:
                    "Image to be used when the blog article is displayed in a tile. For best visual effect, we recommend an image with a 4:3 aspect ratio and a size of at least 560px x 420px.",
                tooltipPosition: "left",
                tab: settingsTab,
            },
            {
                name: fields.publishDate,
                defaultValue: null,
                editorTemplate: "DateTimeField",
                fieldType: "General",
                isRequired: true,
                tab: settingsTab,
            },
            {
                name: fields.author,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "General",
                tab: settingsTab,
            },
        ],
    },
};

export default pageModule;
